const getParameterByName = (name, url = window.location.href) => {
  const parameter_name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${parameter_name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const checkForAnyParamsInURL = ($container) => {
  // INITIAL CHECK FOR URL PARAMS TO SHOW A CERTAIN CATEGORY
  if (getParameterByName('showCategory')) {
    // console.log('showCategory:', getParameterByName('showCategory'));
    showParentItems(getParameterByName('showCategory'), $container);
  }

  // INITIAL CHECK FOR URL PARAMS TO SHOW A CERTAIN CATEGORY AND CHILDREN
  if (getParameterByName('showChildren')) {
    // console.log('showChildren:', getParameterByName('showChildren'));
    showChildrenItems(getParameterByName('showChildren'), $container);
  }

  // INITIAL CHECK TO JUST SHOW THE MAIN CATEGORIES
  if (!getParameterByName('showCategory') && !getParameterByName('showChildren')) {
    // console.log('!showCategory && !showChildren: SHOW ALL CATEGORIES');
    showCategoryItems($container);

    if ($('[data-show-parent-level="true"]').length) {
      // console.log('showProductLevel: true! SHOW ALL PARENTS!!');
      const parentLevelCategory = $('[data-show-parent-level="true"]').data('main-category');
      showParentItems(`${parentLevelCategory}`, $container);

      // console.log('parentLevelCategory:', parentLevelCategory);
      // const state = { category: parentLevelCategory };
      // window.history.replaceState(state, 'category', `?showCategory=${parentLevelCategory}`);
      // showParentItems(`${parentLevelCategory}`, $container);
    }
  }

  return false;
};

const handleStateChanges = (state, title, url) => {
  window.history.pushState(state, title, url);
};

const handleCategoryItemClick = (e, $container) => {
  e.preventDefault();

  const categoryToShow = $(e.currentTarget).data('category-to-show');
  const childrenToShow = $(e.currentTarget).data('children-to-show');
  const historyState = $(e.currentTarget).data('history');

  if (childrenToShow !== undefined) {
    // console.warn('DIRECTLY LINK TO SHOW CHILDREN!');
    const state = { children: childrenToShow };

    if (childrenToShow === '') {
      console.log(e.currentTarget);
      throw Error('Category is missing for tile');
    }

    showChildrenItems(childrenToShow, $container, categoryToShow);
    handleStateChanges(state, 'children', `${historyState}`);
  } else {
    // const categoryToShow = $(e.currentTarget).data('category-to-show');
    // const historyState = $(e.currentTarget).data('history');
    const state = { category: categoryToShow };

    if (categoryToShow === '') {
      console.log(e.currentTarget);
      throw Error('Category is missing for tile');
    }

    showParentItems(categoryToShow, $container);
    handleStateChanges(state, 'category', `${historyState}`);
  }
};

const handleParentItemClick = (e, $container) => {
  e.preventDefault();

  const childrenToShow = $(e.currentTarget).data('children-to-show');
  const historyState = $(e.currentTarget).data('history');
  const state = { children: childrenToShow };

  if (childrenToShow === '') {
    console.log(e.currentTarget);
    throw Error('Category is missing for tile');
  }

  showChildrenItems(childrenToShow, $container);
  handleStateChanges(state, 'children', `${historyState}`);
};

const setHeightsScrollToTop = ($container) => {
  supportGridStandardizeHeights($container);
  scrollToTop();
};

const hideCategoryItems = ($container) => {
  const $categoryItems = $('.ProductRegistrationTile--Category', $container);
  $categoryItems.hide();
};

const hideParentItems = ($container) => {
  const $parentItems = $('.ProductRegistrationTile--Parent', $container);
  $parentItems.hide();
};

const hideChildrenItems = ($container) => {
  const $childrenItems = $('.ProductRegistrationTile--Children', $container);
  $childrenItems.hide();
};

const showCategoryItems = ($container) => {
  const $categoryItems = $('.ProductRegistrationTile--Category', $container);

  if ($categoryItems.length === 0) {
    // window.history.replaceState(null, null, '/pages/register-product');
    return;
  }

  $categoryItems.css('display', 'flex');
  hideParentItems($container);
  hideChildrenItems($container);
  setHeightsScrollToTop($container);
};

const showParentItems = (category, $container) => {
  const $parentItems = $(`[data-category="${category}"]`, $container);

  // if (category === 'allParents') {};

  if ($parentItems.length === 0) {
    // console.log('No parent items found for this category!');
    window.history.replaceState(null, null, window.location.pathname);
    return;
  }

  hideCategoryItems($container);
  $parentItems.css('display', 'flex');
  hideChildrenItems($container);
  setHeightsScrollToTop($container);
};

const showChildrenItems = (childrenToShow, $container, categoryToShow) => {
  let $childrenItems = $(`[data-children="${childrenToShow}"]`, $container);

  // LOGIK TO ALSO ONLY SHOW THE CORRECT CHIDLREN W/IN THE PARENT CATEGORY
  if (categoryToShow !== undefined) {
    // console.warn('categoryToShow:', categoryToShow);
    $childrenItems = $(`[data-category="${categoryToShow}"][data-children="${childrenToShow}"]`, $container);
  }

  if ($childrenItems.length === 0) {
    if (getParameterByName('showCategory')) {
      const currentCategory = getParameterByName('showCategory');
      const state = { category: currentCategory };
      window.history.replaceState(state, 'category', `?showCategory=${currentCategory}`);
      return;
    }

    return;
  }

  hideCategoryItems($container);
  hideParentItems($container);
  $childrenItems.css('display', 'flex');
  setHeightsScrollToTop($container);
};

const scrollToTop = () => {
  $('html, body').animate({ scrollTop: 0 }, 'slow');
};

const verifyChildrenExist = (category, $container) => {
  const $children_items = $(`[data-product-support-child-for='${category}']`, $container);

  if ($children_items.length === 0) {
    return false;
  }

  return true;
};

const checkLocationForChildren = (hash, $container) => {
  const category = hash.substring(1);

  if (verifyChildrenExist(category, $container)) {
    hideParentItems($container);
    displayChildrenItems(category, $container);
  } else {
    const location = window.location.pathname;
    handleStateChanges(null, null, location);
  }
};

const supportGridStandardizeHeights = ($container) => {
  const grid_item_selector = '.ProductSupportTile';
  const child_selectors = [
    // '[data-product-tile-image]',
    '[data-product-tile-title]',
  ];

  standardizeHeights(grid_item_selector, child_selectors, $container);
};

const standardizeHeights = (grid_item_selector, child_selectors, $container = $(document)) => {
  let offset_top = 0;
  let columns = 0;

  $(grid_item_selector, $container).each((i, grid_item) => {
    if (i === 0) {
      offset_top = $(grid_item).offset().top;
    }

    if (offset_top !== $(grid_item).offset().top) {
      columns = i;
      return false;
    }

    return true;
  });

  if (columns === 0) {
    // All items fit on a single row...don't need columns
    columns = $(grid_item_selector).length;
  }

  // console.log('columns:' + columns);

  $(grid_item_selector, $container).each((i, grid_item) => {
    const remainder = i % columns;
    const number_of_siblings = columns - 1;

    if (remainder === 0) {
      // console.log(grid_item);
      // This is the last grid item on the row
      // Grab all siblings to the right, then slice the correct number of siblings to be left for this row
      const $row_siblings = $(grid_item).nextAll().slice(0, number_of_siblings);
      // Add the current item to the array
      $row_siblings.push($(grid_item)[0]);
      // console.log($row_siblings);

      _.each(child_selectors, (selector) => {
        let tallest = 0;

        // Remove any hard-coded heights before comparing
        $row_siblings.find(selector).css('height', '');

        // Compare the heights of all siblings and record the tallest
        $row_siblings.each(function () {
          const height = $(this).find(selector).height();
          // console.log(height);

          if (height > tallest) {
            tallest = height;
          }
        });

        $row_siblings.find(selector).height(tallest);
      });
    }
  });
};

const init = ($container = $(document)) => {
  const $categoryItems = $('.ProductRegistrationTile--Category', $container);
  const $parentItems = $('.ProductRegistrationTile--Parent', $container);
  // const $childrenItems = $('.ProductRegistrationTile--Children', $container);

  checkForAnyParamsInURL($container);
  supportGridStandardizeHeights($container);

  window.addEventListener('popstate', (e) => {
    // console.log(e.state);
    checkForAnyParamsInURL($container);
  });

  $($categoryItems)
    .not('[data-direct-link]')
    .on('click', (e) => {
      handleCategoryItemClick(e, $container);
    });

  $($parentItems)
    .not('[data-direct-link]')
    .on('click', (e) => {
      handleParentItemClick(e, $container);
    });
};

const test = () => {
  console.log('Hello, World!');
  // jquery hello world
  $('body').append('<div>Hello World2!</div>');
};

init();
